import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight, FaTrash,FaImages } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import Swal from "sweetalert2";

const PlanList = () => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/get_all_plans`
        );
        const data = await response.json();
        setPlans(data.data || []);
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchTeamMembers();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/delete_plan/${id}`,
          {
            method: "DELETE",
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          // setPlans((prev) => prev.filter((member) => member._id !== id));
          const updatedList = plans.filter((member) => member._id !== id);
          setPlans(updatedList);

          const totalPagesAfterDelete = Math.ceil(
            updatedList.length / plansPerPage
          );
          if (currentPage > totalPagesAfterDelete) {
            setCurrentPage(totalPagesAfterDelete);
          }

          Swal.fire({
            title: "Deleted!",
            text: "Plan has been deleted.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: data.message || "Failed to delete Plan.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire({
          title: "Error!",
          text: "Server error while deleting.",
          icon: "error",
        });
      }
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const plansPerPage = 10;

  const indexOfLast = currentPage * plansPerPage;
  const indexOfFirst = indexOfLast - plansPerPage;
  const currentPlans = plans.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(plans.length / plansPerPage);

  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }

    return pages.map((page, i) =>
      page === "..." ? (
        <span key={i} className="px-2 text-gray-500 select-none">
          ...
        </span>
      ) : (
        <button
          key={i}
          onClick={() => setCurrentPage(page)}
          className={`px-3 py-1 rounded-full text-sm font-medium ${
            currentPage === page
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {page}
        </button>
      )
    );
  };
  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <>
      <div className="w-fullbg-white px-4">
        <div className="px-4 sm:px-8 py-8 w-full max-w-5xl mx-auto bg-white">
          <h2 className="text-2xl font-bold mb-6 text-center">Plan List</h2>

          <div className="overflow-x-auto rounded-lg shadow bg-white">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-center border py-3 px-4 text-sm font-semibold text-gray-700">
                    S.No.
                  </th>
                  <th className="text-center border py-3 px-4 text-sm font-semibold text-gray-700">
                    Photo
                  </th>
                  <th className="text-center border py-3 px-4 text-sm font-semibold text-gray-700">
                    Title
                  </th>
                  <th className="text-center border py-3 px-4 text-sm font-semibold text-gray-700 flex justify-center items-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentPlans.length > 0 ? (
                  currentPlans.map((plan, index) => (
                    <tr
                      key={plan._id}
                      className="border-t hover:bg-gray-50 transition duration-200 text-center"
                    >
                      <td className="py-3 px-4 text-gray-700">
                        {index + 1 + (currentPage - 1) * 10}
                      </td>
                      <td className="py-3 px-4 text-center">
                        <button onClick={() => setSelectedImage(plan.photo)}>
                          <img
                            src={plan.photo}
                            alt={plan.title}
                            className="w-12 h-12 rounded-full object-cover hover:scale-105 transition"
                          />
                        </button>
                      </td>
                      <td className="py-3 px-4 font-medium text-gray-800 text-center">
                        {plan.title}
                      </td>
                      <td className="py-3 px-4 flex justify-center items-center">
                        <button
                          onClick={() => handleDelete(plan._id)}
                          className="text-red-600 hover:text-red-800 transition"
                          title="Delete"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="py-6 text-gray-500">
                      <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
                        <FaImages className="text-5xl text-gray-300 mb-4" />
                        <p className="text-xl text-gray-500 font-medium">
                          No Plan available.
                        </p>
                        <p className="text-sm text-gray-400 mt-1">
                          Once Plans are uploaded, they’ll show up here.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Image Enlarged View */}
          {selectedImage && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-20 right-32 bg-white p-1 rounded-full shadow hover:bg-gray-100"
              >
                <IoMdClose className="text-black text-xl" />
              </button>
              <div className="relative">
                <img
                  src={selectedImage}
                  alt="Enlarged"
                  className="max-w-full max-h-[90vh] rounded-lg shadow-lg border-4 border-white"
                />
              </div>
            </div>
          )}

          {/* Pagination Controls */}
          {plans.length > 10 && (
            <div className="flex justify-center items-center mt-6 gap-2 flex-wrap">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
              >
                <FaChevronLeft size={14} />
              </button>

              {renderPageNumbers()}

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
              >
                <FaChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlanList;
